<template>
  <details-header :loading="loading">
    <template v-slot:avatar>
      <user-avatar
        :size="80"
        :user="user"
        :color="getColor($vuetify.theme.themes.light.secondarytext, 0.1)"
        textColor="secondarytext"
        cssClass="text-h3"
      >
      </user-avatar>
    </template>
    <template v-slot:headerLine1>
      <template v-if="user.firstName || user.lastName"
        >{{ user.firstName }} {{ user.lastName }}</template
      >
      <template v-else>{{ user.email }}</template>
      <member-status-chip
        :status="user.statusName"
        class="ml-3"
      ></member-status-chip>
    </template>
    <template v-slot:headerLine2>
      <template v-if="user.jobTitle">{{ user.jobTitle }}</template>
    </template>
    <template v-slot:tabs>
      <v-tabs>
        <v-tab :to="getTabLink('')" exact>
          Profile
        </v-tab>
        <v-tab
          :to="getTabLink('coreboard')"
          :disabled="settings.planType == $enums.companyPlanTypes.LITE"
        >
          CoreBoard
        </v-tab>
        <v-tab :to="getTabLink('activity')">Activity</v-tab>
      </v-tabs>
    </template>
    <v-row v-if="tab == ''">
      <v-col cols="12">
        <member-detail-form v-on:delete="deleteMember"> </member-detail-form>
      </v-col>
      <v-col cols="12" v-if="is_manager">
        <managed-member-list></managed-member-list>
      </v-col>
    </v-row>
    <v-row v-if="tab == 'coreboard'">
      <v-col cols="12">
        <core-board
          :items="coreboard_items"
          :user="coreboard_user"
          :manager="coreboard_manager"
          v-on:change="coreBoardId = $event"
        ></core-board>
      </v-col>
    </v-row>
    <v-row v-if="tab == 'activity'">
      <v-col cols="12">
        <activities
          :type-id="$enums.coreCardIdTypes.MEMBER"
          :id="user.id"
        ></activities>
      </v-col>
    </v-row>
  </details-header>
</template>

<script>
import { mapGetters } from "vuex";
import MemberDetailForm from "@/components/members/MemberDetailForm";
import ManagedMemberList from "@/components/members/ManagedMemberList";
import Activities from "@/components/common/Activities";
import DetailsHeader from "@/components/common/DetailsHeader";
import MemberStatusChip from "@/components/members/MemberStatusChip";
import CoreBoard from "@/components/corecard/CoreBoard";
export default {
  name: "MemberDetails",
  components: {
    "member-detail-form": MemberDetailForm,
    Activities,
    "details-header": DetailsHeader,
    "member-status-chip": MemberStatusChip,
    "managed-member-list": ManagedMemberList,
    CoreBoard
  },
  data: () => ({
    tab: null,
    valid: true,
    saving: false,
    deleting: false,
    showManagerReport: false,
    loading: false,
    managedUsersLoading: false,
    coreBoardId: 1
  }),
  computed: {
    userNameForSentList() {
      let text = this.user.firstName || this.user.email;
      if (this.showManagerReport) {
        text += "'s team";
      }
      return text;
    },
    coreboard_user() {
      return this.coreBoardId != 2 ? this.user : null;
    },
    coreboard_manager() {
      return this.coreBoardId == 2 ? this.user : null;
    },
    coreboard_items() {
      if (!this.user.isManager) {
        return [];
      }
      return [
        { id: 1, name: `${this.user.firstName}'s CoreBoard` },
        { id: 2, name: `Team CoreBoard` }
      ];
    },
    ...mapGetters({
      user: "user/edit_user",
      roles: "lookup/app_system_roles",
      is_manager: "user/is_manager",
      managed_users: "user/managed_users",
      settings: "profile/settings",
      teams: "team/teams"
    })
  },
  watch: {},
  created() {
    if (this.user.id == this.$route.params.id && this.teams.length > 0) {
      this.updateTab();
      return;
    }

    this.loading = true;
    Promise.all([
      this.$store.dispatch("user/getUser", this.$route.params.id),
      this.$store.dispatch("team/getTeams"),
      this.$store.dispatch("company/getCustomFields")
    ])
      .then(() => {
        this.updateTab();

        if (this.is_manager) {
          this.managedUsersLoading = true;
          this.$store
            .dispatch("user/getManagedUsers", this.user.id)
            .finally(() => {
              this.managedUsersLoading = false;
            });
        }
      })
      .catch(error => {
        this.logError(error);
        this.$root.$alert(
          "Error Occurred",
          "An error occured while loading this page."
        );
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    getTabLink(tab) {
      return `/members/${this.$route.params.id}${tab == "" ? "" : "/" + tab}`;
    },
    deleteMember() {
      this.$router.push({ path: "/company/members" });
    },
    updateTab() {
      this.tab = this.$route.params.tab || "";
    }
  }
};
</script>
